package music.limasoul.client.shared.navigation

import org.koin.dsl.module

val navigationModule = module {

    factory<Router> {
        get<AppRouter>()
    }

    factory<AppRouter> {
        AppRouter(
            navController = get(),
        )
    }
}